import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHaxeComponent } from './simple-icons-haxe.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHaxeComponent ],
    exports:      [ SimpleIconsHaxeComponent ],
    bootstrap:    []
})
export class SimpleIconsHaxeModule {}
